import ITranslation from "../../interface/translation";
import Message from "../../enum/message";

export default {
    id: 'ru',
    name: 'Русский',
    msg: {
        [Message.mins]: 'мин',
        [Message.checktrue]: 'Да',
        [Message.checkfalse]: 'Нет',
        [Message.checkindetermine]: 'Неизвестно',
        [Message.fieldfrom]: 'Начинается',
        [Message.fieldto]: 'Заканчивается',
        [Message.fieldduration]: 'Длительность',
        [Message.dateonly]: 'Дата',
        [Message.timeonly]: 'Время',
        [Message.record]: 'Запись',
        [Message.owner]: 'Владелец',
        [Message.defaulttablename]: 'Новая таблица',
        [Message.defaultfieldname]: 'Новое поле',
        [Message.emptyevent]: '',
        [Message.globalview]: 'Все',
        [Message.overdue]: 'Минус',
        [Message.notavailable]: 'Н/Д',
        [Message.supportname]: 'Поддержка FrameLink',
        [Message.total]: 'Всего',
        [Message.backup]: 'Копия',
        [Message.emptysheet]: 'Без названия',
        [Message.verifyemailtitle]: 'Подтверждение адреса',
        [Message.verifyemailtext]: 'Спасибо что пользуетесь FrameLink!\nНажмите кнопку «Подтвердить» что бы дать согласие на использование этого адреса в качестве отправителя в системе FrameLink.\nЕсли это письмо адресовано не вам, пожалуйста проигнорируйте это сообщение.',
        [Message.verifyemailsubmit]: 'Подтвердить',
        [Message.verifyphonetext]: 'Спасибо что пользуетесь FrameLink! Перейдите по ссылке [VERIFICATION_LINK] что бы подтвердить свой номер телефона',
        [Message.gdprallow]: 'Разрешить',
        [Message.gdprdecline]: 'Отклонить',
        [Message.copy]: 'Копия',
        [Message.publicformnotification]: 'Уведомление публичной формы'
    }
} as ITranslation;